<template>
  <div class="video">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="内容" name="1">

        <ul class="settingUl">
          <li>
            <span>视频来源</span>
            <el-radio-group v-model="data.videoVis" size="mini">
              <el-radio-button label="本地"></el-radio-button>
              <el-radio-button label="外部"></el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <div class="uloadVideo">
              <i class="el-icon-plus"></i>
              <el-button type="primary" class="tjBtn" size="mini" round @click="handleUpload('1')">上传视频</el-button>
            </div>
          </li>
          <li>
            <span>自动播放</span>
            <el-switch v-model="data.playValue">
            </el-switch>
          </li>
          <li>
            <span>视频封面</span>
            <el-switch v-model="data.fengValue">
            </el-switch>
          </li>
          <li v-if="data.fengValue">
            <div class="uloadVideo" :style="{ backgroundImage: `url(${data.infoImg.src})` }">
              <i class="el-icon-plus"></i>
              <el-button type="primary" class="tjBtn" size="mini" round @click="handleUpload('2')">上传</el-button>
            </div>
          </li>
        </ul>

      </el-collapse-item>
      <el-collapse-item title="样式" name="2">
        <comSetting :infoItme="data.infoItme"/>
      </el-collapse-item>
    </el-collapse>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>

<script>
import imgPre from '../../components/uploadImg/imgPre'
import comSetting from '../comSetting'

export default {
  name: 'videoSetting',
  components: { imgPre, comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      uploadShow: false,
      type: '1'
    }
  },
  methods: {
    handleImg: function (item) {
      if (this.type === '1') {
        this.data.video = item
      } else {
        this.data.infoImg = item
        console.log('选择的图片', item, this.data.infoImg)
      }

      this.uploadShow = false
    },
    handleUpload: function (type) {
      this.type = type
      this.uploadShow = true
    }
  }
}
</script>
<style scoped>
.settingUl {
  padding-right: 20px;
}

.uloadVideo {
  position: relative;
  width: 100%;
  height: 168px;
  background: #f5f5f5;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.el-icon-plus {
  font-size: 24px;
}

.tjBtn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
}

.uloadVideo:hover .tjBtn {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/video/videoSetting.vue